import { render, staticRenderFns } from "./AdPop.vue?vue&type=template&id=bea11db0&scoped=true"
import script from "./AdPop.vue?vue&type=script&lang=js"
export * from "./AdPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea11db0",
  null
  
)

export default component.exports